var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button-upload-file",attrs:{"type":"button","tabindex":"-1","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":"paperclip","size":"is-small"}}),_c('span',[_vm._v("Attach file(s)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }